import React from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import './Footer.css';

const Footer = () => {
    return (
        <>
            <Box sx={{
                marginTop: 'calc(10% + 60px)',
                position: 'fixed',
                bottom: 0,
                width: '100%'
            }}>
                <AppBar position="static">
                    <Toolbar style={{ background: '#4f4f4f' }}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8} sx={{ margin: 'auto' }}>
                                <Typography className="footerMobile" sx={{ textAlign: 'center', fontSize: '16px', padding: '2rem' }}>
                                    To report accessibility issues or submit questions, please email us at <a style={{ color: 'white' }} href='mailto: creditinquiry@tabbank.com'>creditinquiry@tabbank.com</a>.
                                    <br />
                                    <br />
                                    {/* <img alt="" style={{ textAlign: 'center', width: '150px' }} src='https://www.tabbank.com/wp-content/uploads/2016/07/tab-bank-logo-white.png' />
                                    <br />
                                    <br /> */}
                                    © 2024 TAB Bank, All Rights Reserved
                                </Typography>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    )
}

export default Footer;